import { Helmet } from 'react-helmet-async';
import { useSiteData } from '@/hooks/useSiteData';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { Hero } from '@/components/sections/Hero';
import { EngineShowcase } from '@/components/sections/EngineShowcase';
import { LocationMap } from '@/components/sections/LocationMap';
import { PartnerLogos } from '@/components/sections/PartnerLogos';

export function Index() {
  const { siteData } = useSiteData();

  return (
    <>
      <Helmet>
        <title>Home | Engine Overhauls - Annual Inspections</title>
        
        {/* Primary Meta Tags */}
        <meta name="description" content="Complete Engine Overhauls for your Lycoming or Continental powered aircraft in the Augusta Georgia area" />
        <meta name="keywords" content="Lycoming engines,Continental Motors,Cirrus Aircraft,Aircraft Engine Overhaul,Aircraft Engine Repair,Aircraft Engine Maintenance,Prop Strike Inspection,Aircraft Engine overhaul Cost,Aircraft Engine Overhaul Price,Aircraft Annual Inspections,Barn Stormers" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        
        {/* Open Graph Tags */}
        <meta property="og:site_name" content="Watson Aero LLC" />
        <meta property="og:title" content="Home | Engine Overhauls - Annual Inspections" />
        <meta property="og:description" content="Complete Engine Overhauls for your Lycoming or Continental powered aircraft in the Augusta Georgia area" />
        <meta property="og:url" content="https://www.watsonaero.com/" />
        <meta property="og:image" content="https://www.watsonaero.com/uploads/6/0/7/8/60782893/published/watson-aero-llc-copy.png" />
        
        {/* Additional Meta Tags */}
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <link rel="canonical" href="https://www.watsonaero.com/" />
      </Helmet>
      
      <div className="min-h-screen" style={{ backgroundColor: '#f1f1f1' }}>
        <Header 
          navigation={siteData.navigation}
          search={siteData.search}
          companyName={siteData.company.name}
        />
        
        <Hero companyName={siteData.company.name} />
        
        <main id="main-content" className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
          <div id="wsite-content" className="px-4 py-6 sm:px-0">
            <EngineShowcase />
            <LocationMap />
            <PartnerLogos />
          </div>
        </main>
        
        <Footer />
      </div>
    </>
  );
}